import React, { useState } from 'react';
import PropTypes from 'prop-types';
import getContent from 'pp-react-l10n';
import _includes from 'lodash/includes';
import {
  BodyText,
  IconButton,
  V2QuestionSmIcon,
  Sheet,
  Button,
} from '@paypalcorp/pp-react';

const pricingContent = getContent('locals')('guest/reviewFees');

const FeePricing = ({ feeAmounts, getLocalizedCurrency }) => {
  const [openHelperSheet, setOpenHelperSheet] = useState(false);

  let paymentAmount = getLocalizedCurrency(
    feeAmounts?.payment_amount?.value || '0.00',
    feeAmounts?.payment_amount?.currency || 'USD'
  );

  let totalFee = getLocalizedCurrency(
    feeAmounts?.total_fee?.value || '0.00',
    feeAmounts?.total_fee?.currency || 'USD'
  );

  let totalAmountPaid = getLocalizedCurrency(
    feeAmounts?.total_amount_paid?.value || '0.00',
    feeAmounts?.total_amount_paid?.currency || 'USD'
  );

  return (
    <>
      <div className="ppvx_d-flex ppvx_justify-content-between ppvx_align-items-center fee-donation">
        <BodyText>{pricingContent('donation')}</BodyText>
        <BodyText>
          {_includes(paymentAmount, feeAmounts?.payment_amount?.currency)
            ? `${paymentAmount}`
            : `${paymentAmount} ${feeAmounts?.payment_amount?.currency}`}
        </BodyText>
      </div>
      <div className="ppvx_d-flex ppvx_justify-content-between ppvx_align-items-center fee-donation">
        <BodyText>
          {pricingContent('fee')}
          <IconButton
            className="tooltip-icon-button"
            buttonType="tertiary"
            svgIconComponent={V2QuestionSmIcon}
            size="sm"
            onClick={() => setOpenHelperSheet(true)}
          >
            {pricingContent('helperTitle')}
          </IconButton>
        </BodyText>
        <BodyText>
          {_includes(totalFee, feeAmounts?.total_fee?.currency)
            ? `${totalFee}`
            : `${totalFee} ${feeAmounts?.total_fee?.currency}`}
        </BodyText>
      </div>
      <div className="ppvx_d-flex ppvx_justify-content-between ppvx_align-items-center fee-donation">
        <BodyText strong>{pricingContent('total')}</BodyText>
        <BodyText strong>
          {_includes(totalAmountPaid, feeAmounts?.total_amount_paid?.currency)
            ? `${totalAmountPaid}`
            : `${totalAmountPaid} ${feeAmounts?.total_amount_paid?.currency}`}
        </BodyText>
      </div>

      <Sheet
        className="pricing-helper-sheet"
        id="pricing-helper-sheet"
        title={pricingContent('helperTitle')}
        hideTitle={false}
        isOpen={openHelperSheet}
        onClose={() => setOpenHelperSheet(false)}
      >
        <BodyText className="helper-text-description">
          {pricingContent('helperDescription')}
        </BodyText>
        <div className="button-link">
          <Button
            as="a"
            target="_blank"
            href="/webapps/mpp/paypal-fees"
            role="button"
            secondary
          >
            {pricingContent('helperButton')}
          </Button>
        </div>
      </Sheet>
    </>
  );
};

FeePricing.propTypes = {
  feeAmounts: PropTypes.object,
  getLocalizedCurrency: PropTypes.func,
};

export default FeePricing;
